/***** Begin bsCTAFeature Scripts *****/

var bsCTAFeature = {

    toInt: function(str) {
        return parseInt(str.replace('px', ''),10);
    },
    changeModuleHeight: function (ctafeatureId) {

        var myMaxHeight = 0;
        var $myModules = $('#' + ctafeatureId + ' > div, .module');
        var self = this;

        $myModules.each(function (i, j) {
            $(this).css('height', 'auto');
        });

        $myModules.each(function (i, j) {
            myHeight = self.toInt($(this).css('height'));
            if (i == 0) {
                myMaxHeight = self.toInt($(this).css('height'));
            } else {
                if (self.toInt($(this).css('height')) > myMaxHeight) {
                    myMaxHeight = self.toInt($(this).css('height'));
                }
            }            
        });

        $myModules.each(function (i, j) {
            if ($(this).parent().hasClass('oneColumn')) {
                if ((window.innerWidth < 992)) {
                    $(this).css('height', myMaxHeight + 'px');
                } else {
                    $(this).css('height', 'auto');
                }
            } else {
                $(this).css('height', myMaxHeight + 'px');
            }
        });
    }
};

/***** End bsCTAFeature Scripts *****/